// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"506":"e90a8e3e","605":"0fd78844","693":"c9ba4243","805":"f06c865d","910":"2da490f2"}[chunkId] + ".chunk.css";
};